exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".session div.detail-container-row {\n  margin: 15px 0;\n  min-height: 82px;\n  margin-left: 0;\n  border-bottom: 1px solid lightgray;\n}\n.session div.detail-container-row div.detail-container {\n  position: relative;\n}\n.session div.detail-container-row div.detail-container .title {\n  width: 100%;\n  padding-right: 175px;\n  max-width: 100%;\n}\n.session div.detail-container-row div.detail-container ::ng-deep .dropdown {\n  margin-top: -90px;\n}\n.session div.detail-container-row button.add {\n  background: #178ae0;\n  border-radius: 50px;\n  color: #FFF;\n  font-weight: normal;\n  border-bottom: none;\n  bottom: 0;\n  float: right;\n  margin-top: 1.8em;\n  padding: .5em .8em;\n}\n.session ::ng-deep .row {\n  padding-left: 15px;\n  margin: 0px;\n}\n.session .no-teams {\n  margin-top: -30px;\n  padding: 20px 30px;\n  background-color: #fafafa;\n  border-left: 1px solid #e8e8e8;\n  margin-bottom: 30px;\n}\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /home/runner/work/nomadic-admin/nomadic-admin/nomadic-admin/src/app/dashboard/program-list/sessions/session/session.component.less
// module id = ../../../../../src/app/dashboard/program-list/sessions/session/session.component.less
// module chunks = 2